"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identity;
function identity(a) {
  return a;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/identity.js
// module id = 123
// module chunks = 0